import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { da, enGB, enUS, nb, sv } from 'date-fns/locale';
import { ThemeFontSizeVariable, ThemeFontVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Flex, Text } from '@chakra-ui/react';
import { addDays, addMonths, addWeeks, format, getISOWeek, isBefore, isSameMonth, startOfMonth, subDays, subMonths, subWeeks, isSameYear, } from 'date-fns';
import { firstLetterUpperCase } from './datepicker.helper';
import { IconButton } from '@caspeco/casper-ui-library.components.icon-button';
import { Icons } from '@caspeco/casper-ui-library.components.icon';
export const DatePickerHeader = ({ onMonthChange, selectedMonth, month, selectWeek, locale, selectedDate, onDateChange, isExpanded, disablePastMonths, disableBackwardNavigation, disableForwardNavigation, dateRange, onRangeChange, }) => {
    function getWeekPrefix(loc) {
        switch (loc) {
            case enUS:
            case enGB:
                return 'Week';
            case nb:
                return 'Uke';
            case da:
                return 'Uge';
            case sv:
            default:
                return 'Vecka';
        }
    }
    function dateRangeHasValues(range) {
        return !!range?.startDate && !!range?.endDate;
    }
    const isDateRangePicker = !selectWeek && dateRangeHasValues(dateRange) && onRangeChange;
    function getDateRangeDateFormat(range) {
        if (isSameYear(range.startDate, range.endDate)) {
            if (locale === enGB || locale === enUS) {
                return 'MMM d';
            }
            return 'd MMM';
        }
        return 'PP';
    }
    const getHeaderText = () => {
        if (isExpanded) {
            return firstLetterUpperCase(month);
        }
        if (selectWeek) {
            const weekPrefix = getWeekPrefix(locale);
            return `${weekPrefix} ${getISOWeek(selectedDate)}`;
        }
        if (isDateRangePicker) {
            const dateFormat = getDateRangeDateFormat(dateRange);
            const startDate = format(dateRange.startDate, dateFormat, { locale });
            const endDate = format(dateRange.endDate, dateFormat, { locale });
            return `${startDate} - ${endDate}`.replace(/\./g, '');
        }
        if (selectedDate) {
            return format(selectedDate, 'dd MMMM', { locale });
        }
        return firstLetterUpperCase(month);
    };
    const backClick = () => {
        if (isExpanded) {
            onMonthChange(subMonths(startOfMonth(selectedMonth), 1));
        }
        else if (selectWeek) {
            onDateChange(subWeeks(selectedDate, 1));
        }
        else if (isDateRangePicker) {
            onRangeChange({
                startDate: subDays(dateRange.startDate, 1),
                endDate: subDays(dateRange.endDate, 1),
            });
        }
        else {
            onDateChange(subDays(selectedDate, 1));
        }
    };
    const forwardClick = () => {
        if (isExpanded) {
            onMonthChange(addMonths(startOfMonth(selectedMonth), 1));
        }
        else if (selectWeek) {
            onDateChange(addWeeks(selectedDate, 1));
        }
        else if (isDateRangePicker) {
            onRangeChange({
                startDate: addDays(dateRange.startDate, 1),
                endDate: addDays(dateRange.endDate, 1),
            });
        }
        else {
            onDateChange(addDays(selectedDate, 1));
        }
    };
    const currentMonth = startOfMonth(new Date());
    const disableLeftChevron = disableBackwardNavigation ||
        (disablePastMonths &&
            (isBefore(selectedMonth, currentMonth) ||
                isSameMonth(selectedMonth, currentMonth)));
    return (_jsxs(Flex, { justify: "space-between", align: "center", mb: ThemeSpaceVariable.Small, children: [_jsx(IconButton, { icon: Icons.Back, "aria-label": "Back", variant: "ghost", onClick: backClick, isDisabled: disableLeftChevron }), _jsx(Text, { fontWeight: "500", fontFamily: ThemeFontVariable.SubHeader, fontSize: ThemeFontSizeVariable.Large, children: getHeaderText() }), _jsx(IconButton, { icon: Icons.Forward, "aria-label": "Forward", variant: "ghost", onClick: forwardClick, isDisabled: disableForwardNavigation })] }));
};
//# sourceMappingURL=datepicker-header.js.map